import styled from 'styled-components';
import { Z_INDEX_HIGHER } from '@mews-ui/theme';
import { TokenName } from '@mewssystems/design-tokens';
import { getToken } from '@optimus-web/common';
import { ANIMATION_CURVE, ANIMATION_DURATION } from '@optimus-web/local-tokens';
import { alpha } from '../../utils/color';

interface LoadingOverlayProps {
    fixed?: boolean;
    show?: boolean;
}

// opacity tokens use percentage, we need decimal value
const percentToDecimal = (percentage: string) => Number.parseInt(percentage, 10) / 100;

export const LoadingOverlay = styled.div.attrs({ tabIndex: -1 })<LoadingOverlayProps>`
    visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
    position: ${({ fixed }) => (fixed ? 'fixed' : 'absolute')};
    background-color: ${({ theme }) =>
        alpha(
            getToken(TokenName.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_DEFAULT)({ theme }),
            percentToDecimal(getToken(TokenName.OPACITY_800)({ theme }))
        )};
    border-radius: inherit;
    opacity: ${({ show, theme }) => getToken(show ? TokenName.OPACITY_1000 : TokenName.OPACITY_0)({ theme })};
    transition-property: opacity, visibility;
    transition-duration: ${ANIMATION_DURATION.fast}ms;
    transition-timing-function: ${ANIMATION_CURVE.default};
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: ${Z_INDEX_HIGHER};
`;
